import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { savePensionConfig } from '../../services/onboarding'
import {
  getUsers,
  setUserRole,
  updateUserStatusAsync,
} from '../../services/pension'

const initialState = {
  error: null,
  loading: true,
  users: [],
  status: 'idle'
}

/**
 * Gets the list of users.
 */
export const onGetUsersAsync = createAsyncThunk('adminPensionUser/getUsers', async () => {
  const data = await getUsers()
  return data;
})

/**
 * Update user status.
 */
export const onUpdateUserStatusAsync = createAsyncThunk('adminPensionUser/updateStatus', async ({ id, status }) => {
  const response = await updateUserStatusAsync({ id, status });

  return response
});

/**
 * Assign or deactivate an ACL role for a user.
 */
export const onSetUserRoleAsync = createAsyncThunk(
  'adminPensionUser/setRole',
  async ({ userId, roleId, roleName, active }) => {
    await setUserRole({ userId, roleId, active })
    return { userId, roleName, active }
  }
)

/**
 * Admin override of another user's pension method and amount.
 */
export const onSaveUserPensionConfigAsync = createAsyncThunk(
  'adminPensionUser/savePensionConfig',
  async ({ userId, method, amount, percentage, paymentDay }) => {
    await savePensionConfig({
      userId,
      method,
      amount,
      percentage,
      paymentDay,
      allowMethodChange: true,
    })
    return getUsers()
  }
)

export const utmSlice = createSlice({
  name: 'adminPensionUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(onGetUsersAsync.pending, (state) => {
      if (!state.users.length) {
        state.loading = true
      }
      state.error = null
      state.status = 'loading'
    })
    builder.addCase(onGetUsersAsync.fulfilled, (state, action) => {
      state.loading = false
      state.error = null
      state.users = action.payload
      state.status = 'succeeded'
    })
    builder.addCase(onGetUsersAsync.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
      state.status = 'failed'
    })

    builder.addCase(onUpdateUserStatusAsync.pending, (state) => {
      // state.loading = true
    })
    builder.addCase(onUpdateUserStatusAsync.fulfilled, (state, action) => {
      state.loading = false
      state.error = null
      // Update the status in the local state
      const idx = state.users.findIndex(c => c.id === action.payload.id)
      if (idx !== -1) {
        state.users[idx].status = action.payload.status
      }
    })
    builder.addCase(onUpdateUserStatusAsync.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    builder.addCase(onSetUserRoleAsync.fulfilled, (state, action) => {
      const { userId, roleName, active } = action.payload
      const idx = state.users.findIndex((user) => user.id === userId)
      if (idx === -1) return

      const roles = new Set(state.users[idx].roles || [])
      if (active) {
        roles.add(roleName)
      } else {
        roles.delete(roleName)
      }
      state.users[idx].roles = Array.from(roles)
    })

    builder.addCase(onSaveUserPensionConfigAsync.fulfilled, (state, action) => {
      state.users = action.payload
      state.error = null
    })
  }
})

export default utmSlice.reducer
